import { getErrorMsgAndCode, validateInput } from "./FrontendHelpers";
import { AddItemsToWarehouse } from "./ItemHooks";
import { t } from "i18next";

import api from "./axios";

const checkInput = (
  ID,
  Type,
  Items,
  Amounts,
  Comment,
  WarehouseID,
  ClientID
) => {
  const errorArray = [
    {
      Name: "ID",
      Type: "trafficID",
      Value: ID,
      MaxLengthType: "id",
      MinLength: 1,
    },
    {
      Name: "Type",
      Type: "string",
      Value: Type,
      MinLength: 1,
      MaxLengthType: "setType",
    },
    {
      Name: "Items",
      Type: "string",
      Value: Items,
      Message: t("validation.At least one item is required.", { ns: "error" }),
      MinLength: 1,
    },
    {
      Name: "Amounts",
      Type: "string",
      Value: Amounts,
      Message: t("validation.At least one item is required.", { ns: "error" }),
      MinLength: 1,
    },
    {
      Name: "Comment",
      Type: "string",
      Value: Comment,
      MaxLengthType: "largeDetail",
      OnlyCheckLength: true,
      MinLength: 0,
    },
    {
      Name: "WarehouseID",
      Type: "warehouseID",
      Value: WarehouseID,
      Message: t("validation.You must pick a warehouse.", { ns: "error" }),
      MaxLengthType: "id",
      MinLength: 1,
    },
    ...(Type !== "Sale"
      ? [
          {
            Name: "ClientID",
            Type: "clientID",
            Value: ClientID,
            Message: t("validation.You must pick a client.", { ns: "error" }),
            MaxLengthType: "id",
            MinLength: Type === "Sale" ? 0 : 1,
          },
        ]
      : []),
  ];
  console.log("sadsadsadas", Type, Type === "Sale", errorArray);

  return validateInput(errorArray);
};
export async function GetNotes() {
  try {
    const response = await api.get("/getNotes");
    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function CreateNote(props) {
  try {
    console.log("Ammmm actualy", props.ID);
    const errorObj = checkInput(
      props.ID,
      props.Type,
      props.Items,
      props.Amounts,
      props.Comment,
      props.WarehouseID,
      props.ClientID
    );
    console.log("sadsadsadas", errorObj);

    if (errorObj.errCode !== 0) {
      return [null, errorObj];
    }

    const ItemsString = props.Items;
    const ItemsArr = ItemsString.split(",");

    const AmountsString = props.Amounts;
    const AmountsArr = AmountsString.split(",");
    const items = ItemsArr.map((item, index) => {
      return {
        ItemID: item,
        Amount: parseInt(AmountsArr[index]),
      };
    });

    const data = Object.entries(props).reduce((acc, [key, value]) => {
      acc[key] =
        value === undefined || value === null || value === "" ? "/" : value;
      return acc;
    }, {});

    const response = await api.post("/createNote", data);

    const [addData, addError] = await AddItemsToWarehouse(
      data.WarehouseID,
      items,
      data.Type
    );
    if (addError) {
      const [, cleanupError] = await DeleteNote(data.ID);
      if (cleanupError) {
        console.error(
          "Failed to roll back note after stock update failure:",
          data.ID,
          cleanupError
        );
      }
      return [null, addError];
    }

    const result = response.data;

    return [result, null];
  } catch (error) {
    const [, cleanupError] = await DeleteNote(props.ID);
    if (cleanupError) {
      console.error(
        "Failed to roll back note after create failure:",
        props.ID,
        cleanupError
      );
    }
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function DeleteNote(id) {
  try {
    const data = { ID: id };
    const response = await api.post("/deleteNote", data);
    return [response.data, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetNotesInWarehouse(id) {
  try {
    const data = { ID: id };
    const response = await api.post("/getNotesForWarehouse", data);
    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
export async function GetColumnValues(column = "Type") {
  try {
    const data = { Column: column };
    const response = await api.post("/getNoteFieldValues", data);
    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetNotePriceMinMax(id) {
  try {
    const data = { ID: id };
    const response = await api.post("/getNotePriceMinMax", data);
    const result = response.data;
    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetNoteData(argument, bywhat = "TrafficID") {
  try {
    const data = { Argument: argument, byWhat: bywhat };
    const response = await api.post("/getNoteInfo", data);
    const result = response.data;
    return [result[0], null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetNextNoteID() {
  try {
    const response = await api.get("/getNextNoteID");
    const result = response.data;

    return [result.nextID, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function CheckForNote(id) {
  try {
    const data = { ID: id };
    const response = await api.post("/checkForNote", data);
    const info = response.data;
    if (info[0]) {
      return [true, null];
    }

    return [false, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
